import { useEffect, useState } from 'react'
import { sendSmsCode, sendSmsCodeForMerchant } from '../api/smsService'
import { SendSmsCodeInterface } from '../typings/types'

interface TimerOptions extends SendSmsCodeInterface {
  merchantId?: string
}

const useVerificationCodeTimer = (initialSeconds = 60) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds)
  const [isActive, setIsActive] = useState(false)
  const [label, setLabel] = useState('获取验证码')

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = null

    if (isActive && secondsLeft > 0) {
      setLabel(`${secondsLeft}秒后重试`)
      interval = setInterval(() => {
        setSecondsLeft((seconds) => seconds - 1)
      }, 1000)
    } else if (secondsLeft === 0) {
      setIsActive(false)
      setLabel('重新获取')
      setSecondsLeft(initialSeconds)
    }

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [isActive, secondsLeft, initialSeconds])

  const startTimer = (value: TimerOptions) => {
    if (!isActive) {
      const params = {
        ...value,
      }
      const sendSmsRequest = value.merchantId ? sendSmsCodeForMerchant(params) : sendSmsCode(params)
      sendSmsRequest
        .then(() => {
          setIsActive(true)
          setSecondsLeft(initialSeconds)
        })
        .catch(() => {})
    }
  }

  return { label, startTimer, isActive }
}

export default useVerificationCodeTimer
